/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type QueryTextFieldSearchPatientEmbedQueryVariables = {
    query: string;
};
export type QueryTextFieldSearchPatientEmbedQueryResponse = {
    readonly patients: ReadonlyArray<{
        readonly _id: string;
        readonly " $fragmentRefs": FragmentRefs<"ListItemPatientChatActivityEmpty_Patient">;
    } | null> | null;
};
export type QueryTextFieldSearchPatientEmbedQuery = {
    readonly response: QueryTextFieldSearchPatientEmbedQueryResponse;
    readonly variables: QueryTextFieldSearchPatientEmbedQueryVariables;
};



/*
query QueryTextFieldSearchPatientEmbedQuery(
  $query: String!
) {
  patients: patientSearchByText(query: $query) {
    _id
    ...ListItemPatientChatActivityEmpty_Patient
    id
  }
}

fragment AvatarNode_Node on Node {
  __isNode: __typename
  __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
    oid_avatar
    isOnline
  }
  ... on Provider {
    name
    oid_avatar
    isOnline
  }
  ... on User {
    name
    oid_avatar
    isOnline
  }
  ... on ChatActivity {
    patient {
      name
      oid_avatar
      isOnline
      id
    }
  }
}

fragment ListItemPatientChatActivityEmpty_Patient on Patient {
  ...AvatarNode_Node
  firstname
  lastname
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnline",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QueryTextFieldSearchPatientEmbedQuery",
    "selections": [
      {
        "alias": "patients",
        "args": (v1/*: any*/),
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patientSearchByText",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ListItemPatientChatActivityEmpty_Patient"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QueryTextFieldSearchPatientEmbedQuery",
    "selections": [
      {
        "alias": "patients",
        "args": (v1/*: any*/),
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patientSearchByText",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastname",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "groupName",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "type": "Group",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v7/*: any*/),
                "type": "Patient",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v7/*: any*/),
                "type": "Provider",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v7/*: any*/),
                "type": "User",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Patient",
                    "kind": "LinkedField",
                    "name": "patient",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ChatActivity",
                "abstractKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9bca38df0e3cda36344f4f926a493ff2",
    "id": null,
    "metadata": {},
    "name": "QueryTextFieldSearchPatientEmbedQuery",
    "operationKind": "query",
    "text": "query QueryTextFieldSearchPatientEmbedQuery(\n  $query: String!\n) {\n  patients: patientSearchByText(query: $query) {\n    _id\n    ...ListItemPatientChatActivityEmpty_Patient\n    id\n  }\n}\n\nfragment AvatarNode_Node on Node {\n  __isNode: __typename\n  __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on Provider {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on User {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on ChatActivity {\n    patient {\n      name\n      oid_avatar\n      isOnline\n      id\n    }\n  }\n}\n\nfragment ListItemPatientChatActivityEmpty_Patient on Patient {\n  ...AvatarNode_Node\n  firstname\n  lastname\n}\n"
  }
};
})();
(node as any).hash = 'eee3cf66ee523db103c9c5235fa124c0';
export default node;
